<template>
  <div>
    <div class="modal-mask" @mousedown="$emit('close')" style="">
      <div class="modal-wrapper">
        <div id="gameModal" class="modal-container" @mousedown.stop>
          <div class="modal-header">
            <div>
              <div class="d-flex modal_head">
                <div class="modal_imgWrap flex-set width45">
                  <image-component
                    :is_jpg="false"
                    :name="modalItem.game"
                    path="icons"
                    class="borderRadius bgBackground"
                  ></image-component>
                </div>
                <div class="modal_gameInfo text-left paddingM width55">
                  <div class="game_name">
                    <span class="font30 fontExtraBold text333">
                      {{ modalItem.game_kor }}
                    </span>
                  </div>
                  <div class="paddingTB1">
                    <span class="font24 text333">
                      {{ modalItem.game_eng }}
                    </span>
                  </div>
                  <game-info-badge
                    :gameInfo="{
                      kind: modalItem.game_kind,
                      player: modalItem.player,
                    }"
                  ></game-info-badge>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="text-left fontS">
              {{ modalItem.text }}
            </div>
          </div>
          <div class="modal-footer">
            <div
              class="text-left paddingTB1"
              style="border-top: 1px solid lightgray;"
            >
              <span class="font20 fontMedium">게임 스크린샷</span>
            </div>
            <div
              v-for="(item, index) in 2"
              :key="index"
              class="screenshot-wrap"
            >
              <image-component
                :is_jpg="true"
                :name="modalItem.game + (index + 1)"
                path="screenshots"
              ></image-component>
            </div>
            <div
              v-show="check_screenWidth()"
              class="modal-default-button"
              @click="$emit('close')"
            >
              <image-component
                :is_jpg="false"
                name="ic_close"
                path=""
              ></image-component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GameInfoBadge from "../GameInfoBadge.vue";
import imageComponent from "../imageComponent.vue";
export default {
  components: {imageComponent, GameInfoBadge},
  props: {modalItem: Object},
  mounted() {
    window.addEventListener("resize", this.check_screenWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.check_screenWidth);
  },
  methods: {
    check_screenWidth() {
      return screen.width >= 767;
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  position: relative;
  width: 30vw;
  min-width: 250px;
  max-height: 70vh;
  margin: 0px auto;
  padding: 6vw;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: scroll;
}

.modal-body {
  padding-bottom: 50px;
  margin-top: 36px;
}

.modal-default-button {
  position: fixed;
  /* top: 10vh;
  left: 65vw; */
  top: 10px;
  right: 10px;
  /* background-color: #9a9a9a; */
  padding: 0.2rem;
  width: 60px;
  height: 60px;
}
.modal-default-button img {
  width: 100%;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}
.modal-container {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.modal-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
.modal_imgWrap {
  max-width: 180px;
  max-height: 180px;
}
.modal_imgWrap img {
  border-radius: 0 !important;
}
.modal_gameInfo {
  /* padding: 0.5rem 0 1rem 2rem; */
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  padding-left: 10px;
  align-items: flex-start;
}
.modal_gameInfo .kind {
  margin-right: 10px;
}
.screenshot-wrap:nth-child(1) {
  margin: 30px 0;
}
.modal_gameInfo >>> .game-info-wrapper {
  justify-content: start !important;
}
.modal_imgWrap >>> img {
  display: block;
}
</style>
